/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-03-31 10:21:40
 *
 *******************************************************/
//flow
import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { TextStyle } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import Banner from 'src/components/views/common/banners/pfs-banner-custom';
import { URL } from 'src/constants/links';
import { routes } from 'src/routes';
import history from 'src/routes/history';
import { showChatbox } from 'src/integrations/chatbox';
import { isFreemiumPlan } from 'src/helpers/subscription-v4-helper';

import imageBanner from 'src/assets/images/banners/require-upgrade-standard-search.png';
import waveIcon from 'src/assets/images/common/wave-warning-icon.png';

type ComposedProps = Props & WithI18nProps;

class WarningUpgradeBanner extends Component<ComposedProps> {
  render() {
    const { i18n, tenantApp } = this.props;
    const isFreemium = isFreemiumPlan(tenantApp);

    return (
      <Banner
        name="upgradeThemeBanner"
        title={i18n.translate('AdminHTML.Common.UpgradeThemeSetupBanner.title')}
        titleIcon="rocket"
        status="warning"
        hasOutline={true}
        image={imageBanner}
        backgroundImage={waveIcon}
        action={{
          content: i18n.translate('AdminHTML.Common.UpgradeThemeSetupBanner.actionLabel'),
          onAction: () => history.push(routes.themeSetup.view())
        }}
        secondaryAction={{
          content: i18n.translate('AdminHTML.Common.UpgradeThemeSetupBanner.subAction'),
          onAction: () => this.openLink('ThemeSetupV3Doc_learn_more')
        }}>
        <p style={{ minHeight: isFreemium ? 0 : '112px' }}>
          <ul>
            <li>
              {i18n.translate('AdminHTML.Common.UpgradeThemeSetupBanner.paragraph01', {
                t: (
                  <TextStyle variation="strong">
                    {i18n.translate('AdminHTML.Common.UpgradeThemeSetupBanner.paragraph01_t')}
                  </TextStyle>
                )
              })}
            </li>
            {!isFreemium && (
              <li style={{ marginBottom: '16px' }}>
                {i18n.translate('AdminHTML.Common.UpgradeThemeSetupBanner.paragraph02', {
                  t: (
                    <u style={{ cursor: 'pointer' }} onClick={() => this.openChatBox()}>
                      {i18n.translate('AdminHTML.Common.UpgradeThemeSetupBanner.paragraph02_t')}
                    </u>
                  )
                })}
              </li>
            )}
          </ul>
        </p>
      </Banner>
    );
  }
  openLink = (id: string) => {
    const newUrl = URL[id];
    window.open(newUrl, '_blank');
  };

  openChatBox = () => {
    showChatbox();
  };
}

const mapStateToProps = (state, props) => {
  return {
    tenantApp: _.get(state, 'oauth.tenantApp', {})
  };
};

export default withI18n()(connect(mapStateToProps)(WarningUpgradeBanner));
